// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c13f2a7","455":"46741315"}[chunkId] + ".chunk.js";
};